import * as React from 'react';

export function FolderPlus(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20 17.4C20 17.8243 19.8314 18.2313 19.5314 18.5314C19.2313 18.8314 18.8243 19 18.4 19H5.6C5.17565 19 4.76869 18.8314 4.46863 18.5314C4.16857 18.2313 4 17.8243 4 17.4V6.6C4 6.17565 4.16857 5.76869 4.46863 5.46863C4.76869 5.16857 5.17565 5 5.6 5H9.6L11.2 7H18.4C18.8243 7 19.2313 7.16857 19.5314 7.46863C19.8314 7.76869 20 8.17565 20 8.6V17.4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V12H10C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H13V11Z"
        fill="currentColor"
      />
    </svg>
  );
}
